/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from 'react';
import withReactContent from 'sweetalert2-react-content';
import {
  Typography,
  Button,
  IconButton,
  TextField, Grid, makeStyles, InputLabel, Select,
  Checkbox,
  Box,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  CardActions,
  CardMedia,
  List, ListItem, ListItemText, ListItemAvatar, Avatar, Card, CardHeader, CardActionArea, CardContent, DialogTitle
} from "@material-ui/core";
import { InputAdornment, OutlinedInput, FormControl, FormLabel, FormGroup } from '@mui/material';
import Page from '../../components/Page';
import Navbar from '../GetStarted/Navbar';
import NavbarLower from '../GetStarted/NavbarLower';
import Footer from '../pages/Footer';
import MainMenu from '../GetStarted/MainMenu';
import { json, useNavigate } from 'react-router-dom';
import { Signature, Encryption, Countries, GuaranteeTerms } from '../../utils/index'
import { guaranteeTypes, tenures } from '../../utils/guaranteeTypes'

import 'react-phone-input-2/lib/material.css';
import PhoneInput from 'react-phone-input-2';
import { Bloodtype } from '@mui/icons-material';
import MenuItem from '@mui/material/MenuItem';
import TextareaAutosize from 'react-textarea-autosize';
import { FaFileAlt, FaQuestionCircle, FaDownload } from 'react-icons/fa';
import './BacktoTop.css';
import Modal from 'react-modal';
import { Formik, Form, Field, ErrorMessage, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { toWords } from 'number-to-words';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Axios from 'axios';
//import Swal from "sweetalert2";
import Swal from "sweetalert";
import CircularProgress from '@mui/material/CircularProgress';
import { BounceLoader, BeatLoader, PuffLoader, GridLoader } from 'react-spinners';
import ClipLoader from 'react-spinners/ClipLoader';
import FormHelperText from '@mui/material/FormHelperText';
import MultiSelect from '../commons/customSelect.js'
import SearchBar from '../commons/SearchBar.js';
import { FaUpload } from 'react-icons/fa';
import { motion } from 'framer-motion';
import NoteIcon from '@mui/icons-material/Note';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from "@material-ui/core/Paper";
import AcceptTerms from '../commons/acceptTerms.js';
import DescriptionIcon from '@mui/icons-material/Description';
import { ISLIVE, SUCCESS_CODE } from '../../helpers/constants.js';
import { Alert } from '@mui/material';
import { useLocation } from "react-router-dom";
import RefreshIcon from "@material-ui/icons/Refresh";

import {decryptResponse} from '../../helpers/decryptionHelper.js';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
Modal.setAppElement('#root');
const useStyles = makeStyles((theme) => ({
  stepContainer: {
    display: 'flex',
    width: '100%',
    maxWidth: '1000px',
    margin: '0 auto',
    backgroundColor: 'white',
    padding: '10px',
    borderRadius: '20px',
    flexDirection: 'column',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  },
  stepNav: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    flexWrap: 'nowrap',

    // Responsive for tablets and smaller
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },



  step: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 16px', // was 10px 24px
    margin: '2px',
    backgroundColor: '#e0e0e0',
    color: '#333',
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    borderRadius: '999px',

    [theme.breakpoints.down('md')]: {
      width: '80%',
      justifyContent: 'flex-start',
    },
  },

  withConnector: {
    position: 'relative',

    '&::after': {
      content: '""',
      position: 'absolute',
      zIndex: 1,
      backgroundColor: '#ccc',
      top: '50%',
      left: '100%',
      transform: 'translateY(-50%)',
      width: 40,
      height: 2,
      clipPath: 'polygon(0 0, 100% 50%, 0 100%)',
    },

    '&$activeStep::after': {
      backgroundColor: '#290131',
    },

    // Apply vertical layout below md (tablet size and smaller)
    [theme.breakpoints.down('md')]: {
      '&::after': {
        top: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 2,
        height: 40,
        clipPath: 'polygon(0 0, 50% 100%, 100% 0)',
      },
    },
  },

  activeStep: {
    backgroundColor: '#290131',
    color: '#fff',

    '&::after': {
      backgroundColor: '#290131', // active line color
    },
  },
  stepNumber: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 28,
    height: 28,
    marginRight: 8,
    borderRadius: '50%',
    border: '2px solid currentColor',
    fontSize: 14,
    backgroundColor: '#290131'
  },
  stepContent: {
    minHeight: '200px',
    padding: '10px 0',
    transition: 'opacity 0.3s ease',
  },
  navButtons: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    marginTop: '30px',

  },
  goBack: {
    backgroundColor: '#290131',
    color: '#fff',
    padding: '12px 32px',
    border: 'none',
    borderRadius: '999px', // Totally curved
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    marginTop: theme.spacing(4),
    '&:hover': {
      backgroundColor: '#290131',
    },
    '&:focus': {
      outline: 'none',
      boxShadow: '#290131',
    },
  },
  nextStep: {
    backgroundColor: '#f15a24',
    color: '#fff',
    padding: '12px 32px',
    border: 'none',
    borderRadius: '999px', // Totally curved
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    marginTop: theme.spacing(4),
    '&:hover': {
      backgroundColor: '#290131',
    },
    '&:focus': {
      outline: 'none',
      boxShadow: '0 0 0 4px rgba(25, 118, 210, 0.3)',
    },
  },
  centerContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    marginBottom: '2px',
    fontWeight: 'bold',

  },
  quote: {
    backgroundColor: theme.palette.neutral,
    //height: '100%',
    //display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/auth.PNG)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    minHeight: '100vh',
    width: '100%',
  },
  error: {
    color: '#FF0000',
    fontSize: '11px',
  },
  disabled: {
    backgroundColor: '#dcdcdc',
    borderRadius: 4,
  },
  inputRoot: {
    backgroundColor: 'transparent', // So it inherits from parent
  },
  previewButton: {
    backgroundColor: 'transparent',
    border: '1px solid #ccc',
    color: '#1976d2',
    cursor: 'pointer',
  },
  table: {
    minWidth: 100,
  },
  details: {
    color: colors.grey[900],
    backgroundColor: colors.lime[500],
    fontWeight: 800,
    fontSize: 13,
    height: 30,
  },
  Mandatory: {
    color: 'red',
    fontWeight: 800,
  },
  loaderOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  sweetAlertPopup: {
    width: '90% !important',
    maxWidth: '400px',
    textAlign: 'center',
    wordBreak: 'break-word',
  },
  sweetAlertTitle: {
    fontSize: '1rem',
    fontWeight: 700,
    whiteSpace: 'normal !important',
    wordBreak: 'break-word',
    textAlign: 'center',
  },

}));


const validationSchema = Yup.object({
  accountNumber: Yup.string()
    .required('Account number is required')
    .matches(/^\d+$/, 'Only numbers are allowed')
    .min(13, "Account number should not be less than 13 digits")
    .max(13, "Account number should not exceed 13 digits"),
  email: Yup.string().email('Invalid email address'),//.required('Email is required'),
  phone: Yup.string()
    .required('Phone number is required')
    .test('valid-ug-or-global', function (value) {
      const { createError } = this;

      if (!value) {
        return createError({ message: 'Phone number is required' });
      }
      // For Ugandan numbers starting with 256 (without +)
      if (value.startsWith('256')) {
        if (!/^256\d{9}$/.test(value)) {
          return createError({ message: 'Invalid Ugandan phone number. It must be 256 followed by 9 digits.' });
        }
      } else {
        // Global phone numbers must be 7–20 digits
        if (value.length < 7 || value.length > 20) {
          return createError({ message: 'Phone number must be between 7 and 20 digits.' });
        }
      }

      return true;
    }),
    captchaInputValue: Yup.string().required('Fill out the challenge')


});

const DatePickerField = ({ field, form, label, required }) => {

  const { name, value } = field;
  const { setFieldValue, setFieldTouched, touched, errors } = form;

  const error = touched[name] && errors[name];

  return (
    <DatePicker
      selected={value}
      onChange={(date) => setFieldValue(name, date)}
      onBlur={() => setFieldTouched(name, true)}
      dateFormat="yyyy-MM-dd"
      placeholderText="Select a date"
      customInput={
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          label={label}
          required={required}
        //error={!!error}
        //helperText={error}

        />
      }
    />
  );
};

const UGX_MIN = 100;
const UGX_MAX = 10000000000;




export const GuaranteeForm = () => {
  const classes = useStyles();
  const [billing, setBilling] = useState('yearly');
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [activeStep, setActiveStep] = useState(1); // Tracks the current active step

  const [files, setFiles] = useState({});
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  //Defining the different parameters to persist.
  const [dragOverId, setDragOverId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [completeFormLoading, setCompleteFormLoading] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  const [searchResults, setSearchResults] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [error, setError] = useState('');
  const [branches, setBranches] = useState([]);
  const [checked, setChecked] = useState(false);
  const [open, setOpen] = useState(false);
  const [runtimeConfig, setRuntimeConfig] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState("");

  const [secondsLeft, setSecondsLeft] = useState(30);
  const intervalSeconds = 30;
  const handleAlertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };
  const handleFileChange = (e, id) => {
    const fileInput = e.target;
    const file = fileInput.files[0];

    if (!file) {
      setErrors((prev) => ({ ...prev, [id]: 'File is required.' }));
      setFiles((prev) => ({ ...prev, [id]: null }));
      return;
    }

    // Reset the input to allow re-selection of same file
    fileInput.value = '';

    if (file.size > 1 * 1024 * 1024) {
      showError('The file size is greater than 1MB. Please compress your document to fit within 1MB.');
      setErrors((prev) => ({ ...prev, [id]: 'File too large.' }));
      setFiles((prev) => ({ ...prev, [id]: null }));
      return;
    }

    if (file.type !== 'application/pdf') {
      setErrors((prev) => ({ ...prev, [id]: 'Only PDF files are allowed.' }));
      setFiles((prev) => ({ ...prev, [id]: null }));
      return;
    }

    // File is valid
    setErrors((prev) => ({ ...prev, [id]: '' }));
    setFiles((prev) => ({ ...prev, [id]: file }));
  };

  /*useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const updatedConfig = await fetch('/forexRates.json?_t=' + Date.now())
          .then(r => r.json());

        setRuntimeConfig(prevConfig => {
          // Compare previous and new config
          if (JSON.stringify(prevConfig) !== JSON.stringify(updatedConfig)) {
            //console.log("The currency exchange rates have changed: ", updatedConfig);
            return updatedConfig; // Update state
          } else {
            //console.log("No change in currency exchange rates.");
            return prevConfig; // Keep old state
          }
        });

      } catch (error) {
        console.error("Error fetching forex rates:", error);
      }
    }, 5000); // every 5 minutes

    return () => clearInterval(interval);
  }, []);*/
  const location = useLocation();

  useEffect(() => {
    generateCaptchaText();

    const timer = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          generateCaptchaText(); // Regenerate CAPTCHA
          return intervalSeconds;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    //const captcha = generateCaptchaText();
    //setCaptchaValue(captcha);
    // Only start polling if we're on the guarantee page
    if (location.pathname === "/guarantee") {
      const interval = setInterval(async () => {
        try {
          const updatedConfig = await fetch(
            `/forexRates.json?_t=${Date.now()}`
          ).then((r) => r.json());

          setRuntimeConfig((prevConfig) => {
            if (JSON.stringify(prevConfig) !== JSON.stringify(updatedConfig)) {
              //console.log("The currency exchange rates have changed: ",updatedConfig);
              return updatedConfig;
            } else {
              //console.log("No change in currency exchange rates.");
              return prevConfig;
            }
          });
        } catch (error) {
          console.error("Error fetching forex rates:", error);
        }
      }, 30000); // every 30 seconds (change to 5*60*1000 for 5 min)

      return () => clearInterval(interval); // cleanup when leaving page
    }
  }, [location.pathname, setRuntimeConfig]);

  const validationSchemaFillApplication = Yup.object({
    //applicantName: Yup.string().required('Applicant Name is required'),
    applicantAddress: Yup.string().required('Applicant Address is required'),
    applicationDate: Yup.string().required('Application Date Address is required'),
    beneficiaryName: Yup.string().required('Beneficiary Name is required'),
    beneficiaryAddress: Yup.string().required('Beneficiary Address Address is required'),
    /*currency: Yup.string().required('Currency is required'),
    amountInFigures: Yup.number()
    .required('Amount In Figures is required')
    .typeError('Amount In Figures must be a number')
    .min(100000, 'Amount In Figures cannot be less than 100,000')
    .max(10000000000, 'Amount In Figures cannot exceed 10,000,000,000'),*/
    currency: Yup.string().required('Currency is required'),
    amountInFigures: Yup.number()
      .required('Amount In Figures is required')
      .typeError('Amount In Figures must be a number')
      .when('currency', (currency, schema) => {
        if (!currency || !runtimeConfig[currency]) return schema;

        const rateToUGX = runtimeConfig[currency].rateToUGX;
        const minInCurrency = UGX_MIN / rateToUGX;
        const maxInCurrency = UGX_MAX / rateToUGX;

        return schema
          .min(minInCurrency, `Amount cannot be less than ${minInCurrency.toFixed(2)} ${currency}`)
          .max(maxInCurrency, `Amount cannot exceed ${maxInCurrency.toFixed(2)} ${currency}`);
      }),
    amountInWords: Yup.string().required('Amount In Words is required'),
    guaranteeType: Yup.string().required('Guarantee Type is required'),
    contractOrTenderDetails: Yup.string().required('Contract Or TenderDetails is required'),
    tenure: Yup.string().required('Tenure is required'),
    securityValidityDate: Yup.date()
      .required('Security Validity Date is required'),
    branch: Yup.string().required('Branch is required'),
    bidMaturityDate: Yup.date()
      .required('Bid Maturity Date is required'),

  });
  const openPreview = (file) => {
    if (file && file.type === 'application/pdf') {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
      setIsModalOpen(true);
    } else {
      //alert('Only PDF previews are supported');
      showError('Only PDF previews are supported');
    }
  };

  //const [checked, setChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const handleTermsCheck = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);

    if (isChecked) {
      setOpenModal(true);
    }
  };

  const uploadFields = [
    { id: 'bidCopy', label: 'Copy of the Bid format of the guarantee', name: 'bidCopy' },
    { id: 'dataSheet', label: 'Data sheet', name: 'dataSheet' },
    { id: 'companyCard', label: 'Financial Card Document for the company', name: 'companyCard' },
    { id: 'directorsCard', label: 'Financial Card Document for the Directors', name: 'directorsCard' },
    { id: 'directorsID', label: 'National IDs of Directors', name: 'directorsID' },
    { id: 'keyFactsDocument', label: 'Signed Key Facts Document', name: 'keyFactsDocument' },

    { id: 'companyDocuments', label: 'Certificate of Incorporation, Form 18, Form 20, Form 1, Memarts and Trade Licence', name: 'companyDocuments' },
    { id: 'report10', label: 'Report 10', name: 'report10' },
  ];
  const currencyDenominations = [
    "UGX", "USD", "GBP", "KES",
  ]

  //const [files, setFiles] = useState({});
  const [errors, setErrors] = useState({});


  const [text, setText] = useState('');
  const maxChars = 1000;

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const handleDrop = (e, id) => {
    e.preventDefault();
    setDragOverId(null);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && droppedFile.size > 0 && droppedFile.size <= 1 * 1024 * 1024) {
      handleFileChange({ target: { files: [droppedFile] } }, id);
    }
    else {
      showError("The file size is great than 1MB please compress your document to fit in 1MBs");
    }

  };
  const handleDragOver = (e, id) => {
    e.preventDefault();
    setDragOverId(id);
  };
  const handleDragLeave = () => {
    setDragOverId(null);
  };
  const fileInputRefs = useRef({});

  const renderStepContent = () => {
    switch (activeStep) {
      case 1:
        return renderApplicationStart();
      case 2:
        return renderFillApplication();
      case 3:
        return renderUploadDocs();
      case 4:
        return renderCompleteApplication();
      default:
        return null;
    }
  };
  const goToNextStep = (values) => {
    setFormData(prev => ({ ...prev, ...values }));
    setActiveStep(activeStep + 1)
  };

  // Handle previous step
  const goToPreviousStep = () => {
    const captcha = generateCaptchaText();
    setCaptchaValue(captcha);
    setActiveStep(activeStep - 1)
  };

  const getInitialFormData = () => ({
    accountNumber: '',
    email: '',
    phone: '',
    captchaInputValue: '',
    // ...all your fields
    applicantName: '',
    applicantAddress: '',
    applicationDate: `${new Date()?.toLocaleDateString('en-GB')} ${new Date()?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`,
    beneficiaryName: '',
    beneficiaryAddress: '',
    currency: '',
    amountInFigures: '',
    amountInWords: '',
    guaranteeType: '',
    contractOrTenderDetails: '',
    //Section for Documents
    bidSecurityDoc: '',
    bidDataSheetDoc: '',
    financialCardDocumentForCompany: '',
    financialCardDocumentForDirector: '',
    ninOfDirectors: '',
    keyFactsDocument: '',
    companyDocuments: '',
    report10: '',
    tenure: '',
    securityValidityDate: '',
    branch: '',
    bidMaturityDate: ''
  });
  const [formData, setFormData] = useState(
    getInitialFormData()
  );


  const handleSubmitAppstart = async (appStartValues) => {
    //console.log("captchaInputValue is: "+appStartValues.captchaInputValue);
    //console.log("captchaValue is: "+captchaValue);
    if(appStartValues.captchaInputValue===captchaValue){
       GetAccountDetails(appStartValues);
    }
    else{
      alert("Invalid Answer to the challenge, please try again")
    }
    

  }

  const resetAllFileInputs = () => {
    setFiles({});
    setErrors({});

    const inputs = document.querySelectorAll('input[type="file"]');
    inputs.forEach(input => input.value = '');
  };



  const handleSubmitFillApplication = async (fillAppValues) => {
    ////console.log("Saving the FillApplication Data: ",JSON.stringify(fillAppValues));
    //sessionStorage.setItem(SESSION_FORM_APPFILL_DATA, JSON.stringify(fillAppValues));
    setFormData(prev => ({ ...prev, ...fillAppValues }));
    //setFormData(prev => ({ ...prev, applicantName:res.data.Data.name, ...appStartValues }));
    setActiveStep(activeStep + 1)
  }

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };
  const handleSubmitDocuments = async () => {
    const jsonPayload = {};

    if (validateUploads()) {
      for (const [key, file] of Object.entries(files)) {
        if (file && file.type === 'application/pdf') {
          try {
            const base64 = await readFileAsBase64(file);
            jsonPayload[key] = base64;
            if (key === 'dataSheet') {
              ////console.log("Setting the value of datasheet");
              setFormData(prev => ({ ...prev, bidDataSheetDoc: base64 }));
            }
            else if (key === 'bidCopy') {
              ////console.log("Setting the value of bidCopy");
              setFormData(prev => ({ ...prev, bidSecurityDoc: base64 }));
            }
            else if (key === 'companyCard') {
              ////console.log("Setting the value of companyCard");
              setFormData(prev => ({ ...prev, financialCardDocumentForCompany: base64 }));
            } else if (key === 'directorsCard') {
              ////console.log("Setting the value of directorsCard");
              setFormData(prev => ({ ...prev, financialCardDocumentForDirector: base64 }));
            }
            else if (key === 'directorsID') {
              ////console.log("Setting the value of directorsID");
              setFormData(prev => ({ ...prev, ninOfDirectors: base64 }));
            }
            else if (key === 'keyFactsDocument') {
              ////console.log("Setting the value of keyFactsDocument");
              setFormData(prev => ({ ...prev, keyFactsDocument: base64 }));
            }
            else if (key === 'companyDocuments') {
              ////console.log("Setting the value of keyFactsDocument");
              setFormData(prev => ({ ...prev, companyDocuments: base64 }));
            }
            else if (key === 'report10') {
              ////console.log("Setting the value of keyFactsDocument");
              setFormData(prev => ({ ...prev, report10: base64 }));
            }

            //////console.log("The Images "+key +": "+base64);
            ////console.log("The JsonPayLoad is: ",jsonPayload)
          } catch (err) {
            console.error(`Failed to read file ${key}:`, err);
            return;
          }
        }
      }
      setActiveStep(activeStep + 1)
    }
    else {
      ////console.log("Checking error")
      showError("There are some pending documents you need to attached.")
    }
  }


  //const MySwal = withReactContent(Swal);

  const ResponsiveAlert = (title, message, iconType) => {
    /*MySwal.fire({
      title: title,
      html: `
      <p>${message}</p>
      <div style="margin-top: 20px;">
        <div class="swal2-spinner"></div>
      </div>
    `,
      icon: iconType,
      customClass: {
        popup: classes.sweetAlertPopup,
        title: classes.sweetAlertTitle,
      },
      showConfirmButton: true,
      allowOutsideClick: false,
    });*/
    Swal({
          title: title,
          text: message,
          icon: iconType,
          button: "Ok",
    });


  }
  function getAmountInUGX(formData, forexRates) {
    if (formData.currency === 'UGX') {
      //console.log("Amount in UGX is: ", formData.amountInFigures);
      return formData.amountInFigures;
    }
    // Multiply entered amount by the currency's rateToUGX to get UGX equivalent
    const rate = forexRates[formData.currency]?.rateToUGX;
    if (!rate) {
      throw new Error(`Forex rate for ${formData.currency} not found`);
    }
    //console.log("Amount in UGX is: ", formData.amountInFigures * rate);
    return formData.amountInFigures * rate;

  }


  const handleCompleteApplication = async () => {
    setCompleteFormLoading(true);
    const config = {
      headers: {
        "signature": `${signatureValue}`,
        "Content-Type": 'application/json;charset=UTF-8',
      }
    };
    ////console.log("The branch code is: ", formData.branch?.split('*')[0]);
    let values = {
      "accountNumber": formData.accountNumber,
      "emailAddress": formData.email,
      "phoneNumber": formData.phone,
      "applicantName": formData.applicantName,
      "applicantDate": formData.applicationDate,
      "beneficiaryName": formData.beneficiaryName,
      "beneficiaryAddress": formData.beneficiaryAddress,
      "currency": formData.currency,
      //"amountInFigures":formData.amountInFigures,//
      "amountInFigures": getAmountInUGX(formData, runtimeConfig),
      "amountInWords": formData.amountInWords,
      "guaranteeType": formData.guaranteeType,
      "contactOrTenderDetails": formData.contractOrTenderDetails,
      "bidDataSheetDoc": formData.bidDataSheetDoc,
      "bidSecurityDocument": formData.bidSecurityDoc,
      "financialCardDocumentForCompany": formData.financialCardDocumentForCompany,
      "financialCardDocumentForDirectors": formData.financialCardDocumentForDirector,
      "nationalIDsOfDirectors": formData.ninOfDirectors,
      "keyFactsDocument": formData.keyFactsDocument,
      "tenure": formData.tenure,
      "securityValidityDate": formData.securityValidityDate,
      "branchCode": formData.branch?.split('*')[0],
      "bidMaturityDate": formData.bidMaturityDate,
      "companyDocuments": formData.companyDocuments,
      "report10": formData.report10,
      "actualRequestedAmount": formData.amountInFigures //Add to the table
    };
    //console.log("The DATA to server is:", JSON.stringify(values))
    const apiUrl = ISLIVE ? `${window.location.origin}/api/KYC/CreateGuaranteeApplication` : 'http://10.129.2.15:9092/KYC/CreateGuaranteeApplication'; //remote uat
    const objValues = {
      "username": "KYCUI-TEST",
      "applicationID": "KYCUI",
      "where": values,
      "action": "SAVE_DETAILS",
      "query": "KYC",
      "timestamp": `${timestamp}`
      // "encryptCols":["accountName", "accountNumber", "cardNumber", "branch", "email", "phone"]
    }
    const hashedObjValues = Encryption(JSON.stringify(objValues));
    await Axios.post(apiUrl, hashedObjValues, config).then(res => {
      if (res.data.response_code === SUCCESS_CODE) {
        /*Swal.fire({
          title: "Successful Guarantee Application",
          text: res.data.response_message,
          icon: "success",
          showCloseButton: true,
          //timer: 9000,
          //html: 'Your request '+query+' is being processed, check again later after sometime',
          allowOutsideClick: false,
        });*/

        Swal({
          title: "Successful Guarantee Application",
          text: res.data.response_message,
          icon: "success",
          button: "Ok",
        });

        setCompleteFormLoading(false);

        setFormData(getInitialFormData());
        setActiveStep(activeStep - 3)
        resetAllFileInputs();
      } else {
        ////console.log("The Failure response",JSON.stringify(res)); 
        /*Swal.fire({
          title: "Request Failed",
          text: res.data.response_message,
          icon: "error",
          showCancelButton: true,
          allowOutsideClick: false,
        });*/

        Swal({
          title: "Request Failed",
          text: res.data.response_message,
          icon: "error",
          button: "Ok",
        });

        setCompleteFormLoading(false);
      }
    }).catch((error) => {
      //////console.log(error);
      /*Swal.fire({
        title: "Something went wrong",
        text: "Contact the Administrator",
        icon: "error",
        showCancelButton: true,
        allowOutsideClick: false,
      });*/

      Swal({
        title: "Something went wrong",
        text: "Contact the Administrator",
        icon: "error",
        button: "Ok",
      });
      setCompleteFormLoading(false);

    });
  }


  const GetBranches = async () => {
    const apiUrl = ISLIVE ? `${window.location.origin}/api/KYC/GetAvailableBranches` : 'http://10.129.2.15:9092/KYC/GetAvailableBranches';

    const config = {
      headers: {
        "signature": `${signatureValue}`,
        "Content-Type": 'application/json;charset=UTF-8',
        "username": "KYCUI-TEST",
        "applicationID": "KYCUI",
        //"where": appStartValues.accountNumber,
        "action": "VIEW_DETAILS",
        "decryptCols": JSON.stringify(["username"]),
        "query": "KYC",
        "timestamp": `${timestamp}`
      },
    };
    setLoading(true);

    /*await Axios.get(apiUrl, config).then(res => {
      // ////console.log('resp', res)
      ////console.log("The Branches response is: "+ JSON.stringify(res));
      if (res.data.response_code === SUCCESS_CODE) {
        setBranches(JSON.parse(res.data.response_data));
        goToNextStep();
        setLoading(false);
      } else {
        showError(res.data.response_message);
        setLoading(false);
      }
    })*/
   await Axios.get(apiUrl, config)
  .then(res => {
    //Decrypt the encrypted response string
    const decryptedData = decryptResponse(res.data);

    //console.log("Decrypted Branch Response:", decryptedData);

    if (!decryptedData) {
      showError("Failed to decrypt branch response");
      setLoading(false);
      return;
    }

    // Compare using string values
    if (String(decryptedData.response_code) === String(SUCCESS_CODE)) {
      // Parse response_data safely
      const branchList = JSON.parse(decryptedData.response_data || "[]");
      setBranches(branchList);
      goToNextStep();
      setLoading(false);
    } else {
      showError(decryptedData.response_message);
      setLoading(false);
    }
  })
    .catch((_) => {
      showError("A connection Error occurred while retrieving branches");
      setLoading(false);
    });
  }
  const showError = (message) => {
    /*Swal.fire({
      title: 'Failed',
      icon: "error",
      showCloseButton: true,
      timer: 9000,
      html: message,
      allowOutsideClick: true,
      didOpen: () => {
        //Swal.showLoading();
      }
    });*/
      Swal({
          title: 'Failed',
          text: message,
          icon: "error",
          button: "Ok",
      });
  };
  const validateUploads = () => {
    let newErrors = {};
    uploadFields.forEach(({ id, label }) => {
      const file = files[id];
      if (!file) {
        newErrors[id] = `${label} is required.`;
      } else if (file.type !== 'application/pdf') {
        newErrors[id] = `${label} must be a PDF.`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formatNumber1 = (value) => {
    try {
      const num = Number(value);
      if (!isFinite(num)) throw new TypeError("Not a finite number");
      return new Intl.NumberFormat().format(num);
    } catch (err) {
      console.error("formatNumber error:", err);
      return '';
    }
  }
  const formatNumber = (value) => {
    try {
      if (value === null || value === undefined || value === '') return '';

      const num = Number(value);
      if (!isFinite(num)) {
        console.warn("formatNumber warning: not a finite number", value);
        return '';
      }

      return new Intl.NumberFormat().format(num);
    } catch (err) {
      console.error("formatNumber error:", err, value);
      return '';
    }
  };



  /*const unformatNumber = (str) => {
    return str.replace(/,/g, "");
  };*/
  const unformatNumber = (value) => {
    if (typeof value !== 'string') return value;
    const cleaned = value.replace(/[^0-9.]/g, '');
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? null : parsed;
  };


  //SECTION FOR START APPLICATION
  const renderApplicationStart = () => {
    return (
      <Formik
        initialValues={{
          accountNumber: formData.accountNumber,
          email: formData.email,
          countryCode: formData.countryCode,
          phone: formData.phone,
          captchaInputValue: formData.captchaInputValue
        }}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnMount={true}
      >
        {({ values: appStartValues, setFieldValue, handleChange, errors,
          handleBlur,
          // handleSubmit,
          isSubmitting,
          isValid,
          dirty,
          touched,
          setFieldTouched
        }) => (

          <form className="upload-container">

            <h5><b>Welcome to the Pearl Bank Guarantees Application Portal.</b></h5>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <p>Please fill in the details below to proceed.</p>
              </Grid>

              <Grid item xs={12}>
                <p>Account Number<span className={classes.Mandatory}>*</span></p>
                <Field
                  name="accountNumber"
                  //value={appStartValues.accountNumber}
                  //onChange={handleAccountChange}
                  as={TextField}
                  fullWidth
                  variant="outlined"
                  sx={{ mt: 1 }}
                  size="small"
                />
                <ErrorMessage name="accountNumber" component="div" className={classes.error} />
              </Grid>

              <Grid item xs={12}>
                <p>Email Address</p>
                <Field
                  name="email"
                  onChange={handleChange}
                  as={TextField}
                  type="email"
                  fullWidth
                  variant="outlined"
                  size="small"
                  onBlur={() => setFieldTouched('phone', true)}
                //value={appStartValues.email}
                />
                <ErrorMessage name="email" component="div" className={classes.error} />
              </Grid>

              <Grid item xs={12}>
                <p>Phone Number<span className={classes.Mandatory}>*</span></p>
                <PhoneInput
                  name="phone"
                  country={'ug'}
                  enableSearch={true} // allow country search
                  value={appStartValues.phone}
                  onChange={(value) => setFieldValue('phone', value)}
                  inputStyle={{
                    width: '100%',
                    height: '50px',
                    fontSize: '16px',
                  }}
                  containerStyle={{ width: '100%' }}
                />
                <ErrorMessage name="phone" component="div" className={classes.error} />
              </Grid>
              <Grid item xs={12}>
                <p>Fill out the CAPTCHA challenge<span className={classes.Mandatory}>*
                  <small style={{ marginTop: "8px", fontSize: "12px", color: "#555" }}>
                  (New CAPTCHA appears in <strong>{secondsLeft}</strong> seconds)
                </small></span></p>

                  <canvas 
                    ref={canvasRef} 
                    //width="200" 
                    height="50"
                    value={captchaValue}
                    onChange={handleChange}
                    
                    >
                  </canvas>
                  <TextField
                    error={Boolean(errors.captchaInputValue)}
                    helperText={errors.captchaInputValue}
                    className={classes.halftextField}
                    name="captchaInputValue"
                    onChange={handleChange}
                    required
                    margin="normal"
                    onBlur={handleBlur}
                    value={appStartValues.captchaInputValue}
                    variant="outlined"
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={generateCaptchaText} color="secondary">
                            <RefreshIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
              </Grid>



              <Grid item xs={12} style={{ padding: 4, alignItems: 'center', textAlign: 'center' }}>
                <Button type="button" variant="contained"
                  disabled={!(isValid) || loading}
                  color="secondary" className={classes.nextStep}
                  onClick={() => handleSubmitAppstart(appStartValues)}
                >
                  {loading ? (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <ClipLoader color="#0B0B45" loading={loading} size={35} />
                      please wait
                    </div>) : (<>Continue</>)
                  }

                </Button>
              </Grid>
            </Grid>

          </form>
        )}
      </Formik>
    );
  };


  //SECTION FOR FILLING APPLICATION
  const renderFillApplication = () => {
    return (
      <Formik
        initialValues={{
          applicantName: formData.applicantName,
          applicantAddress: formData.applicantAddress,
          applicationDate: formData.applicationDate,
          beneficiaryName: formData.beneficiaryName,
          beneficiaryAddress: formData.beneficiaryAddress,
          currency: formData.currency,
          amountInFigures: formData.amountInFigures,
          amountInWords: formData.amountInWords,
          guaranteeType: formData.guaranteeType,
          contractOrTenderDetails: formData.contractOrTenderDetails,
          tenure: formData.tenure,
          securityValidityDate: formData.securityValidityDate,
          branch: formData.branch,
          bidMaturityDate: formData.bidMaturityDate
        }}
        validateOnMount={true}
        enableReinitialize
        validationSchema={validationSchemaFillApplication}
      >
        {({
          values,
          setFieldValue,
          handleChange,
          handleBlur,
          errors,
          touched,
          isSubmitting,
          isValid,
          dirty,
        }) => (
          <form className="upload-container">
            <h5><b>Guarantee Details</b></h5>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <p>Applicant's Name<span className={classes.Mandatory}>*</span></p>
                <Field
                  name="applicantName"
                  as={TextField}
                  fullWidth
                  size="small"
                  required
                  variant="outlined"
                  //className={classes.disabled}
                  InputProps={{
                    readOnly: true,
                    style: {
                      backgroundColor: '#f5f5f5',
                      color: '#555',
                      fontStyle: 'italic',
                      fontWeight: 800
                    }
                  }}
                />
                <small><ErrorMessage name="applicantName" component="div" className={classes.error} /></small>
              </Grid>

              <Grid item xs={6}>
                <p>Application Date<span className={classes.Mandatory}>*</span></p>
                <Field name="applicationDate">
                  {({ field, form }) => (
                    <TextField
                      {...field}
                      fullWidth
                      size="small"
                      required
                      variant="outlined"
                      value={field.value}
                      InputProps={{
                        readOnly: true,
                        style: {
                          backgroundColor: '#f5f5f5',
                          color: '#555',
                          fontStyle: 'italic',
                          fontWeight: 700
                        }
                      }}
                    />
                  )}
                </Field>
                <small><ErrorMessage name="applicationDate" component="div" className={classes.error} /></small>
              </Grid>

              <Grid item xs={6}>
                <p>Applicant's Address<span className={classes.Mandatory}>*</span></p>
                <Field
                  name="applicantAddress"
                  as={TextField}
                  size="small"
                  fullWidth
                  required
                  variant="outlined"
                />
                <small><ErrorMessage name="applicantAddress" component="div" className={classes.error} /></small>
              </Grid>

              <Grid item xs={6}>
                <p>Beneficiary Name<span className={classes.Mandatory}>*</span></p>
                <Field
                  name="beneficiaryName"
                  as={TextField}
                  size="small"
                  fullWidth
                  required
                  variant="outlined"
                />
                <small><ErrorMessage name="beneficiaryName" component="div" className={classes.error} /></small>
              </Grid>

              <Grid item xs={6}>
                <p>Beneficiary Address<span className={classes.Mandatory}>*</span></p>
                <Field
                  name="beneficiaryAddress"
                  as={TextField}
                  size="small"
                  fullWidth
                  required
                  variant="outlined"
                />
                <small><ErrorMessage name="beneficiaryAddress" component="div" className={classes.error} /></small>
              </Grid>

              <Grid item xs={6}>
                <p>Currency<span className={classes.Mandatory}>*</span></p>
                <Field
                  name="currency"
                  as={Select}
                  variant="outlined"
                  size="small"
                  fullWidth
                  style={{
                    height: '40px',
                    fontSize: '14px',
                    width: '100%',
                  }}
                >
                  <MenuItem
                    key=''
                    value=''
                  //disabled
                  >
                    Currency
                  </MenuItem>
                  {currencyDenominations.map((option, index) => (
                    <MenuItem
                      key={index}
                      value={option}
                    >
                      {option}
                    </MenuItem>
                  ))}

                </Field>
                <small><ErrorMessage name="currency" component="div" className={classes.error} /></small>
              </Grid>


              <Grid item xs={6}>
                <p>Amount in Figures<span className={classes.Mandatory}>*</span></p>
                <Field name="amountInFigures">
                  {({ field, form, meta }) => ( // <<< You MUST destructure 'meta' here
                    <TextField
                      {...field}
                      fullWidth
                      required
                      size="small"
                      variant="outlined"
                      inputMode="numeric"
                      //label="Amount In Figures" // Adding a label for better UX
                      value={
                        (() => {
                          try {
                            const formatted = formatNumber(Number(field.value));
                            return formatted || '';
                          } catch {
                            return '0'; // fallback UI if needed
                          }
                        })()
                      }
                      onChange={(e) => {
                        const raw = unformatNumber(e.target.value);
                        const processedValue = raw === '' || isNaN(Number(raw)) ? '' : Number(raw);
                        form.setFieldValue("amountInFigures", processedValue);
                        if (!isNaN(processedValue) && processedValue <= 10000000000) {
                          form.setFieldValue(
                            "amountInWords",
                            toWords(processedValue).replace(/\b\w/g, (c) => c.toUpperCase())
                          );
                        } else {
                          form.setFieldValue("amountInWords", "");
                        }
                      }}
                    // >>> UNCOMMENT AND USE THESE PROPS <<<
                    //error={meta.touched && !!meta.error} // Pass boolean true/false for error state
                    //helperText={meta.touched && meta.error} // Pass the error message string
                    />
                  )}
                </Field>
                <small>
                  <ErrorMessage
                    name="amountInFigures"
                    component="div"
                    className={classes.error}
                  />
                </small>
              </Grid>
              <Grid item xs={6} >
                <p>Amount in Words<span className={classes.Mandatory}>*</span></p>
                <div //className={classes.disabled}
                >
                  <Field
                    name="amountInWords"
                    as={TextField}
                    size="small"
                    fullWidth
                    required
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                      style: {
                        backgroundColor: '#f5f5f5',
                        color: '#555',
                        fontStyle: 'italic',
                        fontWeight: 700
                      }
                    }}
                  />
                </div>
                <small><ErrorMessage name="amountInWords" component="div" className={classes.error} /></small>
              </Grid>

              <Grid item xs={6}>
                <p>Guarantee Type<span className={classes.Mandatory}>*</span></p>
                <Field
                  name="guaranteeType"
                  as={Select}
                  variant="outlined"
                  fullWidth
                  style={{
                    height: '40px',
                    fontSize: '14px',
                    width: '100%',
                  }}
                >
                  <MenuItem
                    key=''
                    value=''
                  >
                    Select Guarantee Type
                  </MenuItem>
                  {guaranteeTypes.map((type, index) => (
                    <MenuItem
                      key={index}
                      value={type}
                    >
                      {type}
                    </MenuItem>
                  ))}
                </Field>
                <small><ErrorMessage name="guaranteeType" component="div" className={classes.error} /></small>
              </Grid>

              <Grid item xs={6}>
                <p>Tenure<span className={classes.Mandatory}>*</span></p>
                <Field
                  name="tenure"
                  as={Select}
                  variant="outlined"
                  fullWidth
                  style={{
                    height: '40px',
                    fontSize: '14px',
                    width: '100%',
                  }}
                >
                  <MenuItem
                    key=''
                    value=''
                  >
                    Select the tenure
                  </MenuItem>
                  {tenures.map((type, index) => (
                    <MenuItem
                      key={index}
                      value={type}
                    >
                      {type}
                    </MenuItem>
                  ))}
                </Field>
                <small><ErrorMessage name="guaranteeType" component="div" className={classes.error} /></small>
              </Grid>
              <Grid item xs={6} >
                <p>Security Validity Date<span className={classes.Mandatory}>*</span></p>
                <div //className={classes.disabled}
                >
                  <Field
                    name="securityValidityDate"
                    component={DatePickerField}
                    required
                  />
                </div>
                <small><ErrorMessage name="securityValidityDate" component="div" className={classes.error} /></small>
              </Grid>
              <Grid item xs={6}>
                <p>Branch<span className={classes.Mandatory}>*</span></p>
                <Field
                  name="branch"
                  as={Select}
                  variant="outlined"
                  fullWidth
                  style={{
                    height: '40px',
                    fontSize: '14px',
                    width: '100%',
                  }}
                >
                  <MenuItem
                    key=''
                    value=''
                  >
                    Select your preferred branch
                  </MenuItem>
                  {[...branches] // copy to avoid mutating original
                    .sort((a, b) => a.BranchName.localeCompare(b.BranchName))
                    .map((branch, index) => (
                      <MenuItem key={index} value={branch.FinacleBranchCode + "*" + branch.BranchName}>
                        {branch.BranchName}
                      </MenuItem>
                    ))}
                </Field>
                <small><ErrorMessage name="guaranteeType" component="div" className={classes.error} /></small>
              </Grid>
              <Grid item xs={6} >
                <p>Bid Maturity Date<span className={classes.Mandatory}>*</span></p>
                <div //className={classes.disabled}
                >
                  <Field
                    name="bidMaturityDate"
                    component={DatePickerField}
                    required
                  />
                </div>
                <small><ErrorMessage name="bidMaturityDate" component="div" className={classes.error} /></small>
              </Grid>
              {/* Uncomment this when contractOrTenderDetails logic is ready */}
              <Grid item xs={12}>
                <p>
                  Contract / Tender Details<span className={classes.Mandatory}>*</span>
                </p>
                <Field name="contractOrTenderDetails">
                  {({ field, form }) => (
                    <textarea
                      {...field}
                      rows={4}
                      maxLength={maxChars}
                      placeholder="Write your details here..."
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= maxChars) {
                          form.setFieldValue("contractOrTenderDetails", value);
                        }
                      }}
                      style={{
                        width: "100%",
                        padding: "10px",
                        fontSize: "16px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        boxSizing: "border-box",
                      }}
                    />
                  )}
                </Field>

                <div style={{ textAlign: "left" }}>
                  <small>
                    <ErrorMessage name="contractOrTenderDetails" component="div" className={classes.error} />
                  </small>
                </div>

                <div style={{ textAlign: "right" }}>
                  <small>{values.contractOrTenderDetails?.length || 0}/{maxChars} characters</small>
                </div>
              </Grid>

            </Grid>

            {/* Navigation Buttons */}
            <Grid container className={classes.navButtons} sx={{ mt: 2 }}>
              <Grid item>
                <Button
                  type="button"
                  variant="contained"
                  color="secondary"
                  onClick={goToPreviousStep}
                  className={classes.goBack}
                >
                  Previous
                </Button>
              </Grid>
              <Grid item>
                <Button
                  type="button"
                  variant="contained"
                  color="secondary"
                  disabled={Object.keys(errors).length > 0 || isSubmitting}
                  onClick={() => handleSubmitFillApplication(values)}
                  className={classes.nextStep}
                >
                  Continue
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    );
  };

  //Method to get the Account Details:

  const query = "KYC";
  const { timestamp, signatureValue } = Signature(query)

  const GetAccountDetails = async (appStartValues) => {
    ////console.log("The accountNumber is:"+appStartValues.accountNumber)
    const apiUrl = ISLIVE ? `${window.location.origin}/api/KYC/GetAccountNumberDetails` : 'http://10.129.2.15:9092/KYC/GetAccountNumberDetails';

    const config = {
      headers: {
        "signature": `${signatureValue}`,
        "Content-Type": 'application/json;charset=UTF-8',
        "username": "KYCUI-TEST",
        "applicationID": "KYCUI",
        "where": appStartValues.accountNumber,
        "action": "GETACCOUNTDETAILS",
        "decryptCols": JSON.stringify(["username"]),
        "query": "KYC",
        "timestamp": `${timestamp}`
      },
    };
    setLoading(true);
    /*await Axios.get(apiUrl, config).then(res => {
      // ////console.log('resp', res)
      //////console.log("The account validation response is: "+ JSON.stringify(res));
      if (res.data.response_code === SUCCESS_CODE) {
        setLoading(false);
        setFormData(prev => ({ ...prev, applicantName: res.data.Data.name, ...appStartValues }));
        GetBranches();
      } else {
        showError(res.data.response_message);
        setLoading(false);
      }
    })*/
   await Axios.get(apiUrl, config)
  .then(res => {
    try {
      //console.log("Account Val response is",res);
      //console.log("Account Val response Data is",res.data);
      // Step 1: Decrypt the API response
      const decryptedData = decryptResponse(res.data);
      //console.log("Account Val response Data Decrypted is",decryptedData);

      if (!decryptedData) {
        showError("Decryption failed. Invalid data received.");
        setLoading(false);
        return;
      }

      // Step 2: Use decrypted JSON
      if (decryptedData.response_code === SUCCESS_CODE) {
        //console.log("The response is a success with code: ",decryptedData.response_code);
        setLoading(false);
        setFormData(prev => ({
          ...prev,
          applicantName: decryptedData.Data.name,
          ...appStartValues
        }));
        GetBranches();
      } else {
        //console.log("The response is a success with code: ",decryptedData.response_code);
        showError(decryptedData.response_message);
        setLoading(false);
      }
    } catch (e) {
      console.error("Error processing response:", e);
      showError("An unexpected error occurred.");
      setLoading(false);
    }
  })
      .catch((_) => {
        showError("A connection Error occurred while retrieving account");
        setLoading(false);
      });
  }

  const generateCaptchaText = () => {
    const generateSecureRandomString = (length = 6) => {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      const randomBytes = new Uint8Array(length);
      crypto.getRandomValues(randomBytes);
      return Array.from(randomBytes, (byte) => chars[byte % chars.length]).join("");
    };
  
    const getSecureRandomInt = (min, max) => {
      const randomBytes = new Uint32Array(1);
      crypto.getRandomValues(randomBytes);
      return min + (randomBytes[0] % (max - min + 1));
    };
  
    const captchaValue = generateSecureRandomString();
    setCaptchaValue(captchaValue);
  
    const canvas = canvasRef.current;
    if (!canvas) return; 
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  
    // Set dynamic font size based on canvas size
    const fontSize = Math.min(canvas.width / captchaValue.length, 30); // Auto-scale font size
    ctx.font = `bold ${fontSize}px Arial, sans-serif`;
    ctx.fillStyle = "#290131";
    ctx.textBaseline = "middle";
  
    // Adjust character placement
    const startX = 10;
    const spacing = (canvas.width - 20) / captchaValue.length;
    const baseY = canvas.height / 2;
  
    for (let i = 0; i < captchaValue.length; i++) {
      const char = captchaValue[i];
  
      // Randomized but controlled distortions
      const xOffset = getSecureRandomInt(-2, 2);
      const yOffset = getSecureRandomInt(-5, 5);
      const angle = (getSecureRandomInt(-15, 15) * Math.PI) / 180;
  
      const x = startX + i * spacing + xOffset;
      const y = baseY + yOffset;
  
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(char, 0, 0);
      ctx.restore();
    }
  
    // Add noise (lines & dots)
    for (let i = 0; i < 3; i++) {
      ctx.strokeStyle = `rgba(${getSecureRandomInt(50, 200)}, ${getSecureRandomInt(50, 200)}, ${getSecureRandomInt(50, 200)}, 0.7)`;
      ctx.lineWidth = getSecureRandomInt(1, 3);
      ctx.beginPath();
      ctx.moveTo(getSecureRandomInt(0, canvas.width), getSecureRandomInt(0, canvas.height));
      ctx.lineTo(getSecureRandomInt(0, canvas.width), getSecureRandomInt(0, canvas.height));
      ctx.stroke();
    }
  
    for (let i = 0; i < 100; i++) {
      ctx.fillStyle = `rgba(${getSecureRandomInt(0, 255)}, ${getSecureRandomInt(0, 255)}, ${getSecureRandomInt(0, 255)}, 0.5)`;
      ctx.beginPath();
      ctx.arc(
        getSecureRandomInt(0, canvas.width),
        getSecureRandomInt(0, canvas.height),
        getSecureRandomInt(1, 3),
        0,
        2 * Math.PI
      );
      ctx.fill();
    }
    setSecondsLeft(intervalSeconds);
    return captchaValue;
  };
  //SECTION FOR UPLOADING DOCUMENTS

  const renderUploadDocs = () => {
    return (
      <div className="upload-container" style={{ padding: '2rem' }}>
        <h2 style={{ marginBottom: '1.5rem', fontWeight: 600 }}>Upload Required Documents</h2>

        <Grid container spacing={1}>
          {uploadFields.map(({ id, label, name }, index) => {
            const isFirst = index === 0;
            const previousId = index > 0 ? uploadFields[index - 1].id : null;

            // Only show current field if it's the first or previous file is selected
            if (!isFirst && !files[previousId]) return null;

            return (
              <Grid item xs={12} key={id}>
                <div
                  style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    padding: '1rem',
                    background: dragOverId === id ? '#e3f2fd' : '#fafafa',
                    transition: 'background-color 0.3s',
                  }}
                  onDrop={(e) => handleDrop(e, id)}
                  onDragOver={(e) => handleDragOver(e, id)}
                  onDragLeave={handleDragLeave}
                >
                  <Grid container spacing={2} alignItems="center">
                    <Grid
                      item
                      xs={12}
                      md={6}
                      onClick={() => fileInputRefs.current[id]?.click()}
                    >
                      <input
                        type="file"
                        name={name}
                        accept=".pdf"
                        style={{ display: 'none' }}
                        ref={(el) => (fileInputRefs.current[id] = el)}
                        onChange={(e) => handleFileChange(e, id)}
                      />
                      <p>Attach {label}</p>
                      <div
                        style={{
                          cursor: 'pointer',
                          padding: '0.75rem',
                          border: '2px dashed #453737ff',
                          borderRadius: '8px',
                          textAlign: 'center',
                          color: '#666',
                        }}
                      >
                        <p style={{ margin: 0 }}>
                          {files[id]?.name || `Choose file or drag and drop to upload a pdf file`}
                        </p>
                      </div>

                      {errors[id] && (
                        <small className="error-message" style={{ color: 'red' }}>
                          {errors[id]}
                        </small>
                      )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                      {files[id] && (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'right',
                            borderRadius: '6px',
                          }}
                        >
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => openPreview(files[id])}
                            className={classes.previewButton}
                          >
                            Preview
                          </Button>
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            );
          })}
        </Grid>
        {previewUrl && (
          <Modal
            isOpen={isModalOpen}
            onRequestClose={() => setIsModalOpen(false)}
            contentLabel="PDF Preview"
            style={{
              content: {
                maxWidth: '60%',
                height: '70%',
                margin: 'auto',
                padding: 0,
                overflow: 'hidden',
                borderRadius: '10px',
              },
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              <div style={{ padding: '10px', textAlign: 'right', background: '#f0f0f0' }}>
                <Button size="small" onClick={() => setIsModalOpen(false)}>
                  Close ✖
                </Button>
              </div>
              <iframe
                src={previewUrl}
                title="PDF Preview"
                style={{ flex: 1, width: '100%', border: 'none' }}
              />
            </div>
          </Modal>
        )}

        <Grid container className={classes.navButtons} sx={{ mt: 2 }}>
          <Grid item>
            <Button
              type="button"
              variant="outlined"
              color="primary"
              onClick={goToPreviousStep}
              className={classes.goBack}
            >
              Previous
            </Button>
          </Grid>
          <Grid item>
            <Button
              type="button"
              variant="contained"
              color="primary"
              onClick={() => handleSubmitDocuments()}
              className={classes.nextStep}
            //disabled={Object.keys(errors).length > 0}
            >
              Continue
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  };


  const handleDownload = async () => {
    fetch("http://10.129.2.15:9092/KYC/download", {
      method: "GET",
    })
      .then(response => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        ////console.log("The Blob is : ", response)
        return response.blob(); // Read the body once as a Blob
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "key-facts-document.pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
        //window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error("Download failed:", error);
      });

  };





  //SECTION FOR UPLOADING DOCUMENTS
  const renderCompleteApplication = () => {
    return (
      <>
        {completeFormLoading ? (
          <div className={classes.loaderOverlay}>
            <ClipLoader color="#0B0B45" loading={completeFormLoading} size={100} />
            please wait...
          </div>) : (<></>)
        }

        <motion.div
          initial={{ opacity: 0.1 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2 }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <TableContainer component={Paper}>
                <Table className={classes.table} size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell variant="button" display="block" gutterBottom className={classes.details} colSpan='2'><EditNoteIcon style={{ color: '#1976d2', fontSize: 24 }} />Application Information Summary</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/*{basic.map((row) => (*/}
                    <TableRow>
                      <TableCell align="left">Applicant Name</TableCell>
                      <TableCell className={classes.value} align="left">{formData.applicantName}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Account Number</TableCell>
                      <TableCell className={classes.value} align="left">{formData.accountNumber}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Application Date</TableCell>
                      <TableCell className={classes.value} align="left">{formData.applicationDate}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Applicant's Address</TableCell>
                      <TableCell className={classes.value} align="left">{formData.applicantAddress}</TableCell>
                    </TableRow>
                    {formData.email !== '' && (
                      <TableRow>
                        <TableCell align="left">Email Address</TableCell>
                        <TableCell className={classes.value} align="left">{formData.email}</TableCell>
                      </TableRow>
                    )
                    }
                    <TableRow>
                      <TableCell align="left">Beneficiary Name</TableCell>
                      <TableCell className={classes.value} align="left">{formData.beneficiaryName}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Beneficiary Address</TableCell>
                      <TableCell className={classes.value} align="left">{formData.beneficiaryAddress}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Currency</TableCell>
                      <TableCell className={classes.value} align="left">{formData.currency}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Amount in Figures</TableCell>
                      <TableCell className={classes.value} align="left">{formatNumber(formData.amountInFigures)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Amount in Words</TableCell>
                      <TableCell className={classes.value} align="left">{formData.amountInWords}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Guarantee Type</TableCell>
                      <TableCell className={classes.value} align="left">{formData.guaranteeType}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Tenure</TableCell>
                      <TableCell className={classes.value} align="left">{formData.tenure}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Security Validity Date</TableCell>
                      <TableCell className={classes.value} align="left">{formData.securityValidityDate ? new Date(formData.securityValidityDate).toLocaleDateString() : 'N/A'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Bid Maturity Date</TableCell>
                      <TableCell className={classes.value} align="left">{formData.bidMaturityDate ? new Date(formData.bidMaturityDate).toLocaleDateString() : 'N/A'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Preferred Branch</TableCell>
                      <TableCell className={classes.value} align="left">{formData.branch?.split('*')[1]}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Contract / Tender Details</TableCell>
                      <TableCell className={classes.value} align="left">{formData.contractOrTenderDetails}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12} md={12}>
              <TableContainer component={Paper}>
                <Table className={classes.table} size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell variant="button" display="block" gutterBottom className={classes.details} colSpan='2'><DescriptionIcon style={{ color: '#1976d2', fontSize: 24 }} />Document Information Summary</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell align="left">
                        <b>All the required documents have been attached.</b></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12} md={12}>
              <TableContainer component={Paper}>
                <Table className={classes.table} size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell variant="button" display="block" className={classes.details} colSpan='2'><span className={classes.Mandatory}>*</span>Accept Terms & Conditions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <>
                        <Alert
                          severity="warning"
                          style={{ color: 'black' }}
                        >
                          <Checkbox
                            checked={checked}
                            onChange={handleTermsCheck}
                            name="policy"
                          />
                          I/We certify that the information contained in this application is true and correct to the best of my/our knowledge and believe
                          and will form the basis of the guarantee that Post Bank Uganda Limited may decide to issue to me/us.
                          I/We agree with the INDEMNITY forms and conditions stated at the back of this application form
                        </Alert>
                        {/* Modal that opens on check */}
                        <Dialog
                          open={openModal}
                          onClose={() => setOpenModal(false)}
                          fullWidth
                          maxWidth="md"
                        >
                          <DialogTitle>Terms And Conditions</DialogTitle>
                          <DialogContent>
                            {
                              GuaranteeTerms.map((info) => (
                                <Grid item xs={12} md={12} key={info.id}>
                                  <Alert variant="filled" style={{ backgroundColor: "#ffffff", color: "#039BE5", fontSize: 16 }}><b>{info.subject}</b></Alert>
                                  <Card>
                                    <CardContent>
                                      <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.one}</Typography>
                                      <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.two}</Typography>
                                      <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.three}</Typography>
                                      <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.four}</Typography>
                                      <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.five}</Typography>
                                      <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.six}</Typography>
                                      <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.seven}</Typography>
                                      <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.eight}</Typography>
                                      <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.nine}</Typography>
                                      <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.ten}</Typography>
                                      <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.eleven}</Typography>
                                    </CardContent>
                                  </Card>
                                  <br />
                                </Grid>
                              ))}
                            <p>
                              Thank you for accepting the terms.
                            </p>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={() => setOpenModal(false)} color="primary">
                              OK
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
          <Grid container className={classes.navButtons} sx={{ mt: 2 }}>
            <Grid item >
              <Button
                type="button"
                variant="outlined"
                color="primary"
                onClick={goToPreviousStep}
                className={classes.goBack}
              >
                Previous
              </Button>
            </Grid>
            <Grid item>
              <Button
                type="button"
                variant="contained"
                color="primary"
                onClick={() => handleCompleteApplication()}
                //disabled={!checked}
                disabled={!checked}
                className={classes.nextStep}
              //disabled={!isTermsAccepted}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </motion.div>
      </>


    );
  }

  const handleSearch = async (query) => {
    ////console.log("Calling search")
    if (!query) return;
    setLoadingSearch(true);
    setError('');
    try {

      const apiUrl = ISLIVE ? `${window.location.origin}/api/KYC/GetStatusOfApplication` : 'http://10.129.2.15:9092/KYC/GetStatusOfApplication';

      const config = {
        headers: {
          "signature": `${signatureValue}`,
          "Content-Type": 'application/json;charset=UTF-8',
          "username": "KYCUI-TEST",
          "applicationID": "KYCUI",
          "where": query,
          "action": "VIEW_DETAILS",
          "decryptCols": JSON.stringify(["username"]),
          "query": "KYC",
          "timestamp": `${timestamp}`
        },
      };
      //const hashedObjValues = Encryption(JSON.stringify(objValues));
      await Axios.get(apiUrl, config).then(res => {
        ////console.log("Search response is: ", JSON.stringify(res));
        if (res.data.response_code === SUCCESS_CODE) {
          setLoadingSearch(false)
          /*Swal({
            title: "Application Status",
            text:  JSON.parse(res.data.response_data).status,
            icon: "success",
            button: "Ok",
          });*/
          var responseData = JSON.parse(res.data.response_data);
          if (responseData.status === 'PENDING') {
            ResponsiveAlert('Pending Approval', 'Your request ' + query + ' is being processed, check again later after sometime', 'info');
          }
          else if (responseData.status === 'OPSAPPROVAL') {
            ResponsiveAlert('Approved', 'Your request ' + query + ' was approved', 'success');
          }
          else if (responseData.status === 'SCREENED') {
            ResponsiveAlert('Screened', 'Request ' + query + ' is undergoing approval, screening was successful');
          }
          else if (responseData.status.includes("REJECTED")) {
            ResponsiveAlert('Unable to Proceed', 'Request ' + query + ' has been declined at some stage, review in progress', 'error');
          } else {
            /*Swal.fire({
              title: 'Declined',
              icon: "warning",
              showCloseButton: true,
              timer: 9000,
              html: 'Your request ' + query + ' was declined',
              allowOutsideClick: true,
              didOpen: () => {
                //Swal.showLoading();
              }
            });*/
            Swal({
              title: 'Declined',
              icon: "warning",
              button: "Ok",
            });
          }
          //setSearchResults(JSON.parse(res.data.response_data))
        } else {
          ResponsiveAlert('Reference Not Found', 'Please try again with a valid reference Number', 'error');
          setLoadingSearch(false);
        }
      })
    } catch (err) {
      console.error(err);
      setError('Failed to fetch results. Please try again.');
      ResponsiveAlert('Reference Not Found', 'A connection related Error occurred while retrieving application status', 'error');
    } finally {
      setLoadingSearch(false);
    }
  };

  return (
    <div className={classes.quote}>
      <NavbarLower />
      <div style={{ padding: '1rem' }}>

        <SearchBar onSearch={handleSearch} />
        {loadingSearch ? (
          <div className={classes.loaderOverlay}>
            <ClipLoader color="#0B0B45" loading={loadingSearch} size={100} />
            please wait...
          </div>) : (<></>)
        }
      </div>
      <div className={classes.stepContainer}>
        <div className={classes.stepNav}>
          {[1, 2, 3, 4].map((step, index) => (
            <div
              key={step}
              className={`${classes.step} ${activeStep >= step ? classes.activeStep : ''} ${index !== 3 ? classes.withConnector : ''}`}
            >
              <span className={classes.stepNumber}>{step}</span>
              {step === 1 && 'Start Application'}
              {step === 2 && 'Fill Application'}
              {step === 3 && 'Upload Documents'}
              {step === 4 && 'Complete Application'}
            </div>
          ))}
        </div>


        {/* Step content */}
        <div className={classes.stepContent}>
          {renderStepContent()}
        </div>

        {/* Navigation Buttons */}

        {/*<div className={classes.navButtons}>
          {activeStep > 1 && (
            <button className={classes.goBack} onClick={() => setActiveStep(activeStep - 1)}>
              Previous
            </button>
          )}
          {activeStep < 4 && (
            <button className={classes.nextStep} onClick={() => setActiveStep(activeStep + 1)}>
              Next
            </button>
          )}
          {activeStep === 4 && (
            <button className={classes.nextStep} onClick={() => setActiveStep(activeStep + 1)}>
              Submit
            </button>
          )}
        </div>*/}

      </div>
      <Footer />
    </div>
  );
};
export default GuaranteeForm;
